import React from "react";
import AdminTownsCreate from "./AdminTownsComps/AdminTownsCreate";
import AdminTownsGet from "./AdminTownsComps/AdminTownsGet";

export default function AdminTownsMP() {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <a
        style={{
          marginTop: 20,
          fontSize: 20,
          fontWeight: 500,
        }}
      >
        Towns Page
      </a>
      <AdminTownsGet />
      <AdminTownsCreate />
    </div>
  );
}
